import { render } from "./IconRack.vue?vue&type=template&id=5b625e62"
import script from "./IconRack.vue?vue&type=script&lang=ts"
export * from "./IconRack.vue?vue&type=script&lang=ts"
script.render = render

export default script